// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step{
    min-height: 130px;
    background-color: #40c9ff16;
    padding: 10px 5px 5px 5px;
    border-radius: 15px;
    height: 100%;
}

.custom-input-group{
    background-color: #7a6be4;
    padding: 10px 15px;
    border-radius: 20px;
    color: #ffffff;
}

.custom-input-group select{
    padding: 5px 7px;
    border-radius: 20px;
    border: none;
}

.custom-input-group input{
    margin: 0px !important;
    padding: 5px 7px;
    border-radius: 20px;
    border: none;
    width: 100%;
}

.labelStep{
    width: 80px;
}

.step-number{
    position: relative;
    top: 25px;
    left: -20px;
    background-color: #27e5c6;
    border-radius: 10px;
    padding: 0px 20px;
    color: white;
    width: 40px;
    height: 40px;
}

.step-title{
    font-weight: bold;
}

.step button{
    padding: 10px 10px;
    border-radius: 20px;
    border: none;
    background-color: #444258;
    color: #fff;
    font-weight: bold;
}

.custom-btn-generar{
    padding: 10px 10px;
    border-radius: 20px;
    border: none;
    background-color: #27e5c6;
    color: #fff;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/PayBalance/Components/StepsReport.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".step{\r\n    min-height: 130px;\r\n    background-color: #40c9ff16;\r\n    padding: 10px 5px 5px 5px;\r\n    border-radius: 15px;\r\n    height: 100%;\r\n}\r\n\r\n.custom-input-group{\r\n    background-color: #7a6be4;\r\n    padding: 10px 15px;\r\n    border-radius: 20px;\r\n    color: #ffffff;\r\n}\r\n\r\n.custom-input-group select{\r\n    padding: 5px 7px;\r\n    border-radius: 20px;\r\n    border: none;\r\n}\r\n\r\n.custom-input-group input{\r\n    margin: 0px !important;\r\n    padding: 5px 7px;\r\n    border-radius: 20px;\r\n    border: none;\r\n    width: 100%;\r\n}\r\n\r\n.labelStep{\r\n    width: 80px;\r\n}\r\n\r\n.step-number{\r\n    position: relative;\r\n    top: 25px;\r\n    left: -20px;\r\n    background-color: #27e5c6;\r\n    border-radius: 10px;\r\n    padding: 0px 20px;\r\n    color: white;\r\n    width: 40px;\r\n    height: 40px;\r\n}\r\n\r\n.step-title{\r\n    font-weight: bold;\r\n}\r\n\r\n.step button{\r\n    padding: 10px 10px;\r\n    border-radius: 20px;\r\n    border: none;\r\n    background-color: #444258;\r\n    color: #fff;\r\n    font-weight: bold;\r\n}\r\n\r\n.custom-btn-generar{\r\n    padding: 10px 10px;\r\n    border-radius: 20px;\r\n    border: none;\r\n    background-color: #27e5c6;\r\n    color: #fff;\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
